import { render, staticRenderFns } from "./AddMenuGroup.vue?vue&type=template&id=b91cfb62&scoped=true"
import script from "./AddMenuGroup.vue?vue&type=script&lang=js"
export * from "./AddMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./AddMenuGroup.vue?vue&type=style&index=0&id=b91cfb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91cfb62",
  null
  
)

export default component.exports